<template>
  <ams-select-table
    :heading="select_table_heading"
    :ams_api_path="ams_api_path"
    :ams_type="ams_type"
    :ams_fields="ams_fields"
    :describe_belongs_to="describe_belongs_to"
    :filtering="filtering"
    :pre_selected_items="pre_selection"
    :select_mode="mode_selection"
    @selectedRows="selectRows"
  />
</template>

<script>
import AmsSelectTable from './AmsSelectTable.vue'

export default {
  components: {
    AmsSelectTable
  },
  props: {
    pre_selection: {
      Type: Array
    },
    filtering: {
      Type: Object
    },
    select_table_heading: {
      Type: String
    }
  },
  data() {
    return {
      mode_selection: 'single',
      ams_type: 'storage-spaces',
      ams_api_path: 'api/admin/v1',
      ams_fields: [
        {
          key: 'attributes.ancestry',
          label: 'Ancestry',
          sortable: false,
          filterable: true,
          class: 'text-right',
          sortDirection: 'asc',
          // A column that needs custom formatting,
          formatter: 'storageclassification',
        },
        { 
          key: 'attributes.location',
          label: 'Location',
          sortable: false,
          filterable: false,
          class: 'text-left',
          sortDirection: 'asc' 
        },
        { 
          key: 'attributes.storage-access',
          label: 'Storage Access',
          sortable: true,
          filterable: true,
          class: 'text-left',
          sortDirection: 'asc' 
        }
      ],
      describe_belongs_to: [
        {
          prepend: '',
          type: 'collections',
          description_attr: 'name',
          append: ''
        }
      ]
    }
  },
  methods: {
    selectRows(items) {
      this.$emit('selectedItems', items)
    }
  }
}
</script>